export const nigerianStates =  [
	{ id: 1, name: 'Abia' },
	{ id: 2, name: 'Adamawa' },
	{ id: 3, name: 'Akwa Ibom' },
	{ id: 4, name: 'Anambra' },
	{ id: 5, name: 'Bauchi' },
	{ id: 6, name: 'Bayelsa' },
	{ id: 7, name: 'Benue' },
	{ id: 8, name: 'Borno' },
	{ id: 9, name: 'Cross River' },
	{ id: 10, name: 'Delta' },
	{ id: 11, name: 'Ebonyi' },
	{ id: 12, name: 'Edo' },
	{ id: 13, name: 'Ekiti' },
	{ id: 14, name: 'Enugu' },
	{ id: 15, name: 'Gombe' },
	{ id: 16, name: 'Imo' },
	{ id: 17, name: 'Jigawa' },
	{ id: 18, name: 'Kaduna' },
	{ id: 19, name: 'Kano' },
	{ id: 20, name: 'Katsina' },
	{ id: 21, name: 'Kebbi' },
	{ id: 22, name: 'Kogi' },
	{ id: 23, name: 'Kwara' },
	{ id: 24, name: 'Lagos' },
	{ id: 25, name: 'Nasarawa' },
	{ id: 26, name: 'Niger' },
	{ id: 27, name: 'Ogun' },
	{ id: 28, name: 'Ondo' },
	{ id: 29, name: 'Osun' },
	{ id: 30, name: 'Oyo' },
	{ id: 31, name: 'Plateau' },
	{ id: 32, name: 'Rivers' },
	{ id: 33, name: 'Sokoto' },
	{ id: 34, name: 'Taraba' },
	{ id: 35, name: 'Yobe' },
	{ id: 36, name: 'Zamfara' },
	{ id: 37, name: 'FCT' }
];

export const lgas = {
	Abia: [
		{ id: 1, name: 'Aba North' },
		{ id: 2, name: 'Aba South' },
		{ id: 3, name: 'Arochukwu' },
		{ id: 4, name: 'Bende' },
		{ id: 5, name: 'Ikwuano' },
		{ id: 6, name: 'Isiala Ngwa North' },
		{ id: 7, name: 'Isiala Ngwa South' },
		{ id: 8, name: 'Isuikwuato' },
		{ id: 9, name: 'Obi Ngwa' },
		{ id: 10, name: 'Ohafia' },
		{ id: 11, name: 'Osisioma' },
		{ id: 12, name: 'Ugwunagbo' },
		{ id: 13, name: 'Ukwa East' },
		{ id: 14, name: 'Ukwa West' },
		{ id: 15, name: 'Umuahia North' },
		{ id: 16, name: 'Umuahia South' },
		{ id: 17, name: 'Umu Nneochi' }
	],
	Adamawa: [
		{ id: 1, name: 'Demsa' },
		{ id: 2, name: 'Fufure' },
		{ id: 3, name: 'Ganye' },
		{ id: 4, name: 'Gayuk' },
		{ id: 5, name: 'Girei' },
		{ id: 6, name: 'Gombi' },
		{ id: 7, name: 'Hong' },
		{ id: 8, name: 'Jada' },
		{ id: 9, name: 'Lamurde' },
		{ id: 10, name: 'Madagali' },
		{ id: 11, name: 'Maiha' },
		{ id: 12, name: 'Mayo Belwa' },
		{ id: 13, name: 'Michika' },
		{ id: 14, name: 'Mubi North' },
		{ id: 15, name: 'Mubi South' },
		{ id: 16, name: 'Numan' },
		{ id: 17, name: 'Shelleng' },
		{ id: 18, name: 'Song' },
		{ id: 19, name: 'Toungo' },
		{ id: 20, name: 'Yola North' },
		{ id: 21, name: 'Yola South' }
	],
	AkwaIbom: [
		{ id: 1, name: 'Abak' },
		{ id: 2, name: 'Eastern Obolo' },
		{ id: 3, name: 'Eket' },
		{ id: 4, name: 'Esit Eket' },
		{ id: 5, name: 'Essien Udim' },
		{ id: 6, name: 'Etim Ekpo' },
		{ id: 7, name: 'Etinan' },
		{ id: 8, name: 'Ibeno' },
		{ id: 9, name: 'Ibesikpo Asutan' },
		{ id: 10, name: 'Ibiono-Ibom' },
		{ id: 11, name: 'Ika' },
		{ id: 12, name: 'Ikono' },
		{ id: 13, name: 'Ikot Abasi' },
		{ id: 14, name: 'Ikot Ekpene' },
		{ id: 15, name: 'Ini' },
		{ id: 16, name: 'Itu' },
		{ id: 17, name: 'Mbo' },
		{ id: 18, name: 'Mkpat-Enin' },
		{ id: 19, name: 'Nsit-Atai' },
		{ id: 20, name: 'Nsit-Ibom' },
		{ id: 21, name: 'Nsit-Ubium' },
		{ id: 22, name: 'Obot Akara' },
		{ id: 23, name: 'Okobo' },
		{ id: 24, name: 'Onna' },
		{ id: 25, name: 'Oron' },
		{ id: 26, name: 'Oruk Anam' },
		{ id: 27, name: 'Udung-Uko' },
		{ id: 28, name: 'Ukanafun' },
		{ id: 29, name: 'Uruan' },
		{ id: 30, name: 'Urue-Offong/Oruko' },
		{ id: 31, name: 'Uyo' }
	],
	Anambra: [
		{ id: 1, name: 'Aguata' },
		{ id: 2, name: 'Anambra East' },
		{ id: 3, name: 'Anambra West' },
		{ id: 4, name: 'Anaocha' },
		{ id: 5, name: 'Awka North' },
		{ id: 6, name: 'Awka South' },
		{ id: 7, name: 'Ayamelum' },
		{ id: 8, name: 'Dunukofia' },
		{ id: 9, name: 'Ekwusigo' },
		{ id: 10, name: 'Idemili North' },
		{ id: 11, name: 'Idemili South' },
		{ id: 12, name: 'Ihiala' },
		{ id: 13, name: 'Njikoka' },
		{ id: 14, name: 'Nnewi North' },
		{ id: 15, name: 'Nnewi South' },
		{ id: 16, name: 'Ogbaru' },
		{ id: 17, name: 'Onitsha North' },
		{ id: 18, name: 'Onitsha South' },
		{ id: 19, name: 'Orumba North' },
		{ id: 20, name: 'Orumba South' },
		{ id: 21, name: 'Oyi' }
	],
	Bauchi: [
		{ id: 1, name: 'Alkaleri' },
		{ id: 2, name: 'Bauchi' },
		{ id: 3, name: 'Bogoro' },
		{ id: 4, name: 'Damban' },
		{ id: 5, name: 'Darazo' },
		{ id: 6, name: 'Dass' },
		{ id: 7, name: 'Gamawa' },
		{ id: 8, name: 'Ganjuwa' },
		{ id: 9, name: 'Giade' },
		{ id: 10, name: 'Itas/Gadau' },
		{ id: 11, name: 'Jama\'are' },
		{ id: 12, name: 'Katagum' },
		{ id: 13, name: 'Kirfi' },
		{ id: 14, name: 'Misau' },
		{ id: 15, name: 'Ningi' },
		{ id: 16, name: 'Shira' },
		{ id: 17, name: 'Tafawa Balewa' },
		{ id: 18, name: 'Toro' },
		{ id: 19, name: 'Warji' },
		{ id: 20, name: 'Zaki' }
	],
	Bayelsa: [
		{ id: 1, name: 'Brass' },
		{ id: 2, name: 'Ekeremor' },
		{ id: 3, name: 'Kolokuma/Opokuma' },
		{ id: 4, name: 'Nembe' },
		{ id: 5, name: 'Ogbia' },
		{ id: 6, name: 'Sagbama' },
		{ id: 7, name: 'Southern Ijaw' },
		{ id: 8, name: 'Yenagoa' }
	],
	Benue: [
		{ id: 1, name: 'Ado' },
		{ id: 2, name: 'Agatu' },
		{ id: 3, name: 'Apa' },
		{ id: 4, name: 'Buruku' },
		{ id: 5, name: 'Gboko' },
		{ id: 6, name: 'Guma' },
		{ id: 7, name: 'Gwer East' },
		{ id: 8, name: 'Gwer West' },
		{ id: 9, name: 'Katsina-Ala' },
		{ id: 10, name: 'Konshisha' },
		{ id: 11, name: 'Kwande' },
		{ id: 12, name: 'Logo' },
		{ id: 13, name: 'Makurdi' },
		{ id: 14, name: 'Obi' },
		{ id: 15, name: 'Ogbadibo' },
		{ id: 16, name: 'Ohimini' },
		{ id: 17, name: 'Oju' },
		{ id: 18, name: 'Okpokwu' },
		{ id: 19, name: 'Oturkpo' },
		{ id: 20, name: 'Tarka' },
		{ id: 21, name: 'Ukum' },
		{ id: 22, name: 'Ushongo' },
		{ id: 23, name: 'Vandeikya' }
	],
	Borno: [
		{ id: 1, name: 'Abadam' },
		{ id: 2, name: 'Askira/Uba' },
		{ id: 3, name: 'Bama' },
		{ id: 4, name: 'Bayo' },
		{ id: 5, name: 'Biu' },
		{ id: 6, name: 'Chibok' },
		{ id: 7, name: 'Damboa' },
		{ id: 8, name: 'Dikwa' },
		{ id: 9, name: 'Gubio' },
		{ id: 10, name: 'Guzamala' },
		{ id: 11, name: 'Gwoza' },
		{ id: 12, name: 'Hawul' },
		{ id: 13, name: 'Jere' },
		{ id: 14, name: 'Kaga' },
		{ id: 15, name: 'Kala/Balge' },
		{ id: 16, name: 'Konduga' },
		{ id: 17, name: 'Kukawa' },
		{ id: 18, name: 'Kwaya Kusar' },
		{ id: 19, name: 'Mafa' },
		{ id: 20, name: 'Magumeri' },
		{ id: 21, name: 'Maiduguri' },
		{ id: 22, name: 'Marte' },
		{ id: 23, name: 'Mobbar' },
		{ id: 24, name: 'Monguno' },
		{ id: 25, name: 'Ngala' },
		{ id: 26, name: 'Nganzai' },
		{ id: 27, name: 'Shani' }
	],
	CrossRiver: [
		{ id: 1, name: 'Abi' },
		{ id: 2, name: 'Akamkpa' },
		{ id: 3, name: 'Akpabuyo' },
		{ id: 4, name: 'Bakassi' },
		{ id: 5, name: 'Bekwarra' },
		{ id: 6, name: 'Biase' },
		{ id: 7, name: 'Boki' },
		{ id: 8, name: 'Calabar Municipal' },
		{ id: 9, name: 'Calabar South' },
		{ id: 10, name: 'Etung' },
		{ id: 11, name: 'Ikom' },
		{ id: 12, name: 'Obanliku' },
		{ id: 13, name: 'Obubra' },
		{ id: 14, name: 'Obudu' },
		{ id: 15, name: 'Odukpani' },
		{ id: 16, name: 'Ogoja' },
		{ id: 17, name: 'Yakuur' },
		{ id: 18, name: 'Yala' }
	],
	Delta: [
		{ id: 1, name: 'Aniocha North' },
		{ id: 2, name: 'Aniocha South' },
		{ id: 3, name: 'Bomadi' },
		{ id: 4, name: 'Burutu' },
		{ id: 5, name: 'Ethiope East' },
		{ id: 6, name: 'Ethiope West' },
		{ id: 7, name: 'Ika North East' },
		{ id: 8, name: 'Ika South' },
		{ id: 9, name: 'Isoko North' },
		{ id: 10, name: 'Isoko South' },
		{ id: 11, name: 'Ndokwa East' },
		{ id: 12, name: 'Ndokwa West' },
		{ id: 13, name: 'Okpe' },
		{ id: 14, name: 'Oshimili North' },
		{ id: 15, name: 'Oshimili South' },
		{ id: 16, name: 'Patani' },
		{ id: 17, name: 'Sapele' },
		{ id: 18, name: 'Udu' },
		{ id: 19, name: 'Ughelli North' },
		{ id: 20, name: 'Ughelli South' },
		{ id: 21, name: 'Ukwuani' },
		{ id: 22, name: 'Uvwie' },
		{ id: 23, name: 'Warri North' },
		{ id: 24, name: 'Warri South' },
		{ id: 25, name: 'Warri South West' }
	],
	Ebonyi: [
		{ id: 1, name: 'Abakaliki' },
		{ id: 2, name: 'Afikpo North' },
		{ id: 3, name: 'Afikpo South (Edda)' },
		{ id: 4, name: 'Ebonyi' },
		{ id: 5, name: 'Ezza North' },
		{ id: 6, name: 'Ezza South' },
		{ id: 7, name: 'Ikwo' },
		{ id: 8, name: 'Ishielu' },
		{ id: 9, name: 'Ivo' },
		{ id: 10, name: 'Izzi' },
		{ id: 11, name: 'Ohaozara' },
		{ id: 12, name: 'Ohaukwu' },
		{ id: 13, name: 'Onicha' }
	],
	Edo: [
		{ id: 1, name: 'Akoko-Edo' },
		{ id: 2, name: 'Egor' },
		{ id: 3, name: 'Esan Central' },
		{ id: 4, name: 'Esan North-East' },
		{ id: 5, name: 'Esan South-East' },
		{ id: 6, name: 'Esan West' },
		{ id: 7, name: 'Etsako Central' },
		{ id: 8, name: 'Etsako East' },
		{ id: 9, name: 'Etsako West' },
		{ id: 10, name: 'Igueben' },
		{ id: 12, name: 'Ikpoba Okha' },
		{ id: 13, name: 'Orhionmwon' },
		{ id: 14, name: 'Oredo' },
		{ id: 15, name: 'Ovia North-East' },
		{ id: 16, name: 'Ovia South-West' },
		{ id: 17, name: 'Owan East' },
		{ id: 18, name: 'Owan West' },
		{ id: 19, name: 'Uhunmwonde' }
	],
	Ekiti: [
		{ id: 1, name: 'Ado Ekiti' },
		{ id: 2, name: 'Efon' },
		{ id: 3, name: 'Ekiti East' },
		{ id: 4, name: 'Ekiti South-West' },
		{ id: 5, name: 'Ekiti West' },
		{ id: 6, name: 'Emure' },
		{ id: 7, name: 'Gbonyin' },
		{ id: 8, name: 'Ido Osi' },
		{ id: 9, name: 'Ijero' },
		{ id: 10, name: 'Ikere' },
		{ id: 11, name: 'Ikole' },
		{ id: 12, name: 'Ilejemeje' },
		{ id: 13, name: 'Irepodun/Ifelodun' },
		{ id: 14, name: 'Ise/Orun' },
		{ id: 15, name: 'Moba' },
		{ id: 16, name: 'Oye' }
	],
	Enugu: [
		{ id: 1, name: 'Aninri' },
		{ id: 2, name: 'Awgu' },
		{ id: 3, name: 'Enugu East' },
		{ id: 4, name: 'Enugu North' },
		{ id: 5, name: 'Enugu South' },
		{ id: 6, name: 'Ezeagu' },
		{ id: 7, name: 'Igbo Etiti' },
		{ id: 8, name: 'Igbo Eze North' },
		{ id: 9, name: 'Igbo Eze South' },
		{ id: 10, name: 'Isi Uzo' },
		{ id: 11, name: 'Nkanu East' },
		{ id: 12, name: 'Nkanu West' },
		{ id: 13, name: 'Nsukka' },
		{ id: 14, name: 'Oji River' },
		{ id: 15, name: 'Udenu' },
		{ id: 16, name: 'Udi' },
		{ id: 17, name: 'Uzo-Uwani' }
	],
	Gombe: [
		{ id: 1, name: 'Akko' },
		{ id: 2, name: 'Balanga' },
		{ id: 3, name: 'Billiri' },
		{ id: 4, name: 'Dukku' },
		{ id: 5, name: 'Funakaye' },
		{ id: 6, name: 'Gombe' },
		{ id: 7, name: 'Kaltungo' },
		{ id: 8, name: 'Kwami' },
		{ id: 9, name: 'Nafada' },
		{ id: 10, name: 'Shongom' },
		{ id: 11, name: 'Yamaltu/Deba' }
	],
	Imo: [
		{ id: 1, name: 'Aboh Mbaise' },
		{ id: 2, name: 'Ahiazu Mbaise' },
		{ id: 3, name: 'Ehime Mbano' },
		{ id: 4, name: 'Ezinihitte'},
		{ id: 5, name: 'Ideato North' },
		{ id: 6, name: 'Ideato South' },
		{ id: 7, name: 'Ihitte/Uboma' },
		{ id: 8, name: 'Ikeduru' },
		{ id: 9, name: 'Isiala Mbano' },
		{ id: 10, name: 'Isu' },
		{ id: 11, name: 'Mbaitoli' },
		{ id: 12, name: 'Ngor Okpala' },
		{ id: 13, name: 'Njaba' },
		{ id: 14, name: 'Nkwerre' },
		{ id: 15, name: 'Nwangele' },
		{ id: 16, name: 'Obowo' },
		{ id: 17, name: 'Oguta' },
		{ id: 18, name: 'Ohaji/Egbema' },
		{ id: 19, name: 'Okigwe' },
		{ id: 20, name: 'Orlu' },
		{ id: 21, name: 'Orsu' },
		{ id: 22, name: 'Oru East' },
		{ id: 23, name: 'Oru West' },
		{ id: 24, name: 'Owerri Municipal' },
		{ id: 25, name: 'Owerri North' },
		{ id: 26, name: 'Owerri West' },
		{ id: 27, name: 'Unuimo' }
	],
	Jigawa: [
		{ id: 1, name: 'Auyo' },
		{ id: 2, name: 'Babura' },
		{ id: 3, name: 'Biriniwa' },
		{ id: 4, name: 'Birnin Kudu' },
		{ id: 5, name: 'Buji' },
		{ id: 6, name: 'Dutse' },
		{ id: 7, name: 'Gagarawa' },
		{ id: 8, name: 'Garki' },
		{ id: 9, name: 'Gumel' },
		{ id: 10, name: 'Guri' },
		{ id: 11, name: 'Gwaram' },
		{ id: 12, name: 'Gwiwa' },
		{ id: 13, name: 'Hadejia' },
		{ id: 14, name: 'Jahun' },
		{ id: 15, name: 'Kafin Hausa' },
		{ id: 16, name: 'Kaugama' },
		{ id: 17, name: 'Kazaure' },
		{ id: 18, name: 'Kiri Kasama' },
		{ id: 19, name: 'Kiyawa' },
		{ id: 20, name: 'Maigatari' },
		{ id: 21, name: 'Malam Madori' },
		{ id: 22, name: 'Miga' },
		{ id: 23, name: 'Ringim' },
		{ id: 24, name: 'Roni' },
		{ id: 25, name: 'Sule Tankarkar' },
		{ id: 26, name: 'Taura' },
		{ id: 27, name: 'Yankwashi' }
	],
	Kaduna: [
		{ id: 1, name: 'Birnin Gwari' },
		{ id: 2, name: 'Chikun' },
		{ id: 3, name: 'Giwa' },
		{ id: 4, name: 'Igabi' },
		{ id: 5, name: 'Ikara' },
		{ id: 6, name: 'Jaba' },
		{ id: 7, name: 'Jema\'a' },
		{ id: 8, name: 'Kachia' },
		{ id: 9, name: 'Kaduna North' },
		{ id: 10, name: 'Kaduna South' },
		{ id: 11, name: 'Kagarko' },
		{ id: 12, name: 'Kajuru' },
		{ id: 13, name: 'Kaura' },
		{ id: 14, name: 'Kauru' },
		{ id: 15, name: 'Kubau' },
		{ id: 16, name: 'Kudan' },
		{ id: 17, name: 'Lere' },
		{ id: 18, name: 'Makarfi' },
		{ id: 19, name: 'Sabon Gari' },
		{ id: 20, name: 'Sanga' },
		{ id: 21, name: 'Soba' },
		{ id: 22, name: 'Zangon Kataf' },
		{ id: 23, name: 'Zaria' }
	],
	Kano: [
		{ id: 1, name: 'Ajingi' },
		{ id: 2, name: 'Albasu' },
		{ id: 3, name: 'Bagwai' },
		{ id: 4, name: 'Bebeji' },
		{ id: 5, name: 'Bichi' },
		{ id: 6, name: 'Bunkure' },
		{ id: 7, name: 'Dala' },
		{ id: 8, name: 'Dambatta' },
		{ id: 9, name: 'Dawakin Kudu' },
		{ id: 10, name: 'Dawakin Tofa' },
		{ id: 11, name: 'Doguwa' },
		{ id: 12, name: 'Fagge' },
		{ id: 13, name: 'Gabasawa' },
		{ id: 14, name: 'Garko' },
		{ id: 15, name: 'Garun Mallam' },
		{ id: 16, name: 'Gaya' },
		{ id: 17, name: 'Gezawa' },
		{ id: 18, name: 'Gwale' },
		{ id: 19, name: 'Gwarzo' },
		{ id: 20, name: 'Kabo' },
		{ id: 21, name: 'Kano Municipal' },
		{ id: 22, name: 'Karaye' },
		{ id: 23, name: 'Kibiya' },
		{ id: 24, name: 'Kiru' },
		{ id: 25, name: 'Kumbotso' },
		{ id: 26, name: 'Kunchi' },
		{ id: 27, name: 'Kura' },
		{ id: 28, name: 'Madobi' },
		{ id: 29, name: 'Makoda' },
		{ id: 30, name: 'Minjibir' },
		{ id: 31, name: 'Nasarawa' },
		{ id: 32, name: 'Rano' },
		{ id: 33, name: 'Rimin Gado' },
		{ id: 34, name: 'Rogo' },
		{ id: 35, name: 'Shanono' },
		{ id: 36, name: 'Sumaila' },
		{ id: 37, name: 'Takai' },
		{ id: 38, name: 'Tarauni' },
		{ id: 39, name: 'Tofa' },
		{ id: 40, name: 'Tsanyawa' },
		{ id: 41, name: 'Tudun Wada' },
		{ id: 42, name: 'Ungogo' },
		{ id: 43, name: 'Warawa' },
		{ id: 44, name: 'Wudil' }
	],
	Katsina: [
		{ id: 1, name: 'Bakori' },
		{ id: 2, name: 'Batagarawa' },
		{ id: 3, name: 'Batsari' },
		{ id: 4, name: 'Baure' },
		{ id: 5, name: 'Bindawa' },
		{ id: 6, name: 'Charanchi' },
		{ id: 7, name: 'Dandume' },
		{ id: 8, name: 'Danja' },
		{ id: 9, name: 'Dan Musa' },
		{ id: 10, name: 'Daura' },
		{ id: 11, name: 'Dutsi' },
		{ id: 12, name: 'Dutsin Ma' },
		{ id: 13, name: 'Faskari' },
		{ id: 14, name: 'Funtua' },
		{ id: 15, name: 'Ingawa' },
		{ id: 16, name: 'Jibia' },
		{ id: 17, name: 'Kafur' },
		{ id: 18, name: 'Kaita' },
		{ id: 19, name: 'Kankara' },
		{ id: 20, name: 'Kankia' },
		{ id: 21, name: 'Katsina' },
		{ id: 22, name: 'Kurfi' },
		{ id: 23, name: 'Kusada' },
		{ id: 24, name: 'Mai\'Adua' },
		{ id: 25, name: 'Malumfashi' },
		{ id: 26, name: 'Mani' },
		{ id: 27, name: 'Mashi' },
		{ id: 28, name: 'Matazu' },
		{ id: 29, name: 'Musawa' },
		{ id: 30, name: 'Rimi' },
		{ id: 31, name: 'Sabuwa' },
		{ id: 32, name: 'Safana' },
		{ id: 33, name: 'Sandamu' },
		{ id: 34, name: 'Zango' }
	],
	Kebbi: [
		{ id: 1, name: 'Aleiro' },
		{ id: 2, name: 'Arewa Dandi' },
		{ id: 3, name: 'Argungu' },
		{ id: 4, name: 'Augie' },
		{ id: 5, name: 'Bagudo' },
		{ id: 6, name: 'Birnin Kebbi' },
		{ id: 7, name: 'Bunza' },
		{ id: 8, name: 'Dandi' },
		{ id: 9, name: 'Fakai' },
		{ id: 10, name: 'Gwandu' },
		{ id: 11, name: 'Jega' },
		{ id: 12, name: 'Kalgo' },
		{ id: 13, name: 'Koko/Besse' },
		{ id: 14, name: 'Maiyama' },
		{ id: 15, name: 'Ngaski' },
		{ id: 16, name: 'Sakaba' },
		{ id: 17, name: 'Shanga' },
		{ id: 18, name: 'Suru' },
		{ id: 19, name: 'Wasagu/Danko' },
		{ id: 20, name: 'Yauri' },
		{ id: 21, name: 'Zuru' }
	],
	Kogi: [
		{ id: 1, name: 'Adavi' },
		{ id: 2, name: 'Ajaokuta' },
		{ id: 3, name: 'Ankpa' },
		{ id: 4, name: 'Bassa' },
		{ id: 5, name: 'Dekina' },
		{ id: 6, name: 'Ibaji' },
		{ id: 7, name: 'Idah' },
		{ id: 8, name: 'Igalamela Odolu' },
		{ id: 9, name: 'Ijumu' },
		{ id: 10, name: 'Kabba/Bunu' },
		{ id: 11, name: 'Kogi' },
		{ id: 12, name: 'Lokoja' },
		{ id: 13, name: 'Mopa Muro' },
		{ id: 14, name: 'Ofu' },
		{ id: 15, name: 'Ogori/Magongo' },
		{ id: 16, name: 'Okehi' },
		{ id: 17, name: 'Okene' },
		{ id: 18, name: 'Olamaboro' },
		{ id: 19, name: 'Omala' },
		{ id: 20, name: 'Yagba East' },
		{ id: 21, name: 'Yagba West' }
	],
	Kwara: [
		{ id: 1, name: 'Asa' },
		{ id: 2, name: 'Baruten' },
		{ id: 3, name: 'Edu' },
		{ id: 4, name: 'Ekiti' },
		{ id: 5, name: 'Ifelodun' },
		{ id: 6, name: 'Ilorin East' },
		{ id: 7, name: 'Ilorin South' },
		{ id: 8, name: 'Ilorin West' },
		{ id: 9, name: 'Irepodun' },
		{ id: 10, name: 'Isin' },
		{ id: 11, name: 'Kaiama' },
		{ id: 12, name: 'Moro' },
		{ id: 13, name: 'Offa' },
		{ id: 14, name: 'Oke Ero' },
		{ id: 15, name: 'Oyun' },
		{ id: 16, name: 'Pategi' }
	],
	Lagos: [
		{ id: 1, name: 'Agege' },
		{ id: 2, name: 'Ajeromi-Ifelodun' },
		{ id: 3, name: 'Alimosho' },
		{ id: 4, name: 'Amuwo-Odofin' },
		{ id: 5, name: 'Apapa' },
		{ id: 6, name: 'Badagry' },
		{ id: 7, name: 'Epe' },
		{ id: 8, name: 'Eti Osa' },
		{ id: 9, name: 'Ibeju-Lekki' },
		{ id: 10, name: 'Ifako-Ijaiye' },
		{ id: 11, name: 'Ikeja' },
		{ id: 12, name: 'Ikorodu' },
		{ id: 13, name: 'Kosofe' },
		{ id: 14, name: 'Lagos Island' },
		{ id: 15, name: 'Lagos Mainland' },
		{ id: 16, name: 'Mushin' },
		{ id: 17, name: 'Ojo' },
		{ id: 18, name: 'Oshodi-Isolo' },
		{ id: 19, name: 'Shomolu' },
		{ id: 20, name: 'Surulere' }
	],
	Nasarawa: [
		{ id: 1, name: 'Akwanga' },
		{ id: 2, name: 'Awe' },
		{ id: 3, name: 'Doma' },
		{ id: 4, name: 'Karu' },
		{ id: 5, name: 'Keana' },
		{ id: 6, name: 'Keffi' },
		{ id: 7, name: 'Kokona' },
		{ id: 8, name: 'Lafia' },
		{ id: 9, name: 'Nasarawa' },
		{ id: 10, name: 'Nasarawa Egon' },
		{ id: 11, name: 'Obi' },
		{ id: 12, name: 'Toto' },
		{ id: 13, name: 'Wamba' }
	],
	Niger: [
		{ id: 1, name: 'Agaie' },
		{ id: 2, name: 'Agwara' },
		{ id: 3, name: 'Bida' },
		{ id: 4, name: 'Borgu' },
		{ id: 5, name: 'Bosso' },
		{ id: 6, name: 'Chanchaga' },
		{ id: 7, name: 'Edati' },
		{ id: 8, name: 'Gbako' },
		{ id: 9, name: 'Gurara' },
		{ id: 10, name: 'Katcha' },
		{ id: 12, name: 'Kontagora' },
		{ id: 13, name: 'Lapai' },
		{ id: 14, name: 'Lavun' },
		{ id: 15, name: 'Magama' },
		{ id: 16, name: 'Mariga' },
		{ id: 17, name: 'Mashegu' },
		{ id: 18, name: 'Mokwa' },
		{ id: 19, name: 'Moya' },
		{ id: 20, name: 'Paikoro' },
		{ id: 21, name: 'Rafi' },
		{ id: 22, name: 'Rijau' },
		{ id: 23, name: 'Shiroro' },
		{ id: 24, name: 'Suleja' },
		{ id: 25, name: 'Tafa' },
		{ id: 26, name: 'Wushishi' }
	],
	Ogun: [
		{ id: 1, name: 'Abeokuta North' },
		{ id: 2, name: 'Abeokuta South' },
		{ id: 3, name: 'Ado-Odo/Ota' },
		{ id: 4, name: 'Ewekoro' },
		{ id: 5, name: 'Ifo' },
		{ id: 6, name: 'Ijebu East' },
		{ id: 7, name: 'Ijebu North' },
		{ id: 8, name: 'Ijebu North East' },
		{ id: 9, name: 'Ijebu Ode' },
		{ id: 10, name: 'Ikenne' },
		{ id: 11, name: 'Imeko Afon' },
		{ id: 12, name: 'Ipokia' },
		{ id: 13, name: 'Obafemi Owode' },
		{ id: 14, name: 'Odeda' },
		{ id: 15, name: 'Odogbolu' },
		{ id: 16, name: 'Ogun Waterside' },
		{ id: 17, name: 'Remo North' },
		{ id: 18, name: 'Shagamu' },
		{ id: 19, name: 'Yewa North' },
		{ id: 20, name: 'Yewa South' }
	],
	Ondo: [
		{ id: 1, name: 'Akoko North-East' },
		{ id: 2, name: 'Akoko North-West' },
		{ id: 3, name: 'Akoko South-East' },
		{ id: 4, name: 'Akoko South-West' },
		{ id: 5, name: 'Akure North' },
		{ id: 6, name: 'Akure South' },
		{ id: 7, name: 'Ese Odo' },
		{ id: 8, name: 'Idanre' },
		{ id: 9, name: 'Ifedore' },
		{ id: 10, name: 'Ilaje' },
		{ id: 11, name: 'Ile Oluji/Okeigbo' },
		{ id: 12, name: 'Irele' },
		{ id: 13, name: 'Odigbo' },
		{ id: 14, name: 'Okitipupa' },
		{ id: 15, name: 'Ondo East' },
		{ id: 16, name: 'Ondo West' },
		{ id: 17, name: 'Ose' },
		{ id: 18, name: 'Owo' }
	],
	Osun: [
		{ id: 1, name: 'Aiyedaade' },
		{ id: 2, name: 'Aiyedire' },
		{ id: 3, name: 'Atakunmosa East' },
		{ id: 4, name: 'Atakunmosa West' },
		{ id: 5, name: 'Boluwaduro' },
		{ id: 6, name: 'Boripe' },
		{ id: 7, name: 'Ede North' },
		{ id: 8, name: 'Ede South' },
		{ id: 9, name: 'Egbedore' },
		{ id: 10, name: 'Ejigbo' },
		{ id: 11, name: 'Ife Central' },
		{ id: 12, name: 'Ife East' },
		{ id: 13, name: 'Ife North' },
		{ id: 14, name: 'Ife South' },
		{ id: 15, name: 'Ifedayo' },
		{ id: 16, name: 'Ifelodun' },
		{ id: 17, name: 'Ila' },
		{ id: 18, name: 'Ilesa East' },
		{ id: 19, name: 'Ilesa West' },
		{ id: 20, name: 'Irepodun' },
		{ id: 21, name: 'Irewole' },
		{ id: 22, name: 'Isokan' },
		{ id: 23, name: 'Iwo' },
		{ id: 24, name: 'Obokun' },
		{ id: 25, name: 'Odo Otin' },
		{ id: 26, name: 'Ola Oluwa' },
		{ id: 27, name: 'Olorunda' },
		{ id: 28, name: 'Oriade' },
		{ id: 29, name: 'Orolu' },
		{ id: 30, name: 'Osogbo' }
	],
	Oyo: [
		{ id: 1, name: 'Afijio' },
		{ id: 2, name: 'Akinyele' },
		{ id: 3, name: 'Atiba' },
		{ id: 4, name: 'Atisbo' },
		{ id: 5, name: 'Egbeda' },
		{ id: 6, name: 'Ibadan North' },
		{ id: 7, name: 'Ibadan North-East' },
		{ id: 8, name: 'Ibadan North-West' },
		{ id: 9, name: 'Ibadan South-East' },
		{ id: 10, name: 'Ibadan South-West' },
		{ id: 11, name: 'Ibarapa Central' },
		{ id: 12, name: 'Ibarapa East' },
		{ id: 13, name: 'Ibarapa North' },
		{ id: 14, name: 'Ido' },
		{ id: 15, name: 'Irepo' },
		{ id: 16, name: 'Iseyin' },
		{ id: 17, name: 'Itesiwaju' },
		{ id: 18, name: 'Iwajowa' },
		{ id: 19, name: 'Kajola' },
		{ id: 20, name: 'Lagelu' },
		{ id: 21, name: 'Ogbomosho North' },
		{ id: 22, name: 'Ogbomosho South' },
		{ id: 23, name: 'Ogo Oluwa' },
		{ id: 24, name: 'Olorunsogo' },
		{ id: 25, name: 'Oluyole' },
		{ id: 26, name: 'Ona Ara' },
		{ id: 27, name: 'Orelope' },
		{ id: 28, name: 'Ori Ire' },
		{ id: 29, name: 'Oyo East' },
		{ id: 30, name: 'Oyo West' },
		{ id: 31, name: 'Saki East' },
		{ id: 32, name: 'Saki West' },
		{ id: 33, name: 'Surulere' }
	],
	Plateau: [
		{ id: 1, name: 'Bokkos' },
		{ id: 2, name: 'Barkin Ladi' },
		{ id: 3, name: 'Bassa' },
		{ id: 4, name: 'Jos East' },
		{ id: 5, name: 'Jos North' },
		{ id: 6, name: 'Jos South' },
		{ id: 7, name: 'Kanam' },
		{ id: 8, name: 'Kanke' },
		{ id: 9, name: 'Langtang North' },
		{ id: 10, name: 'Langtang South' },
		{ id: 11, name: 'Mangu' },
		{ id: 12, name: 'Mikang' },
		{ id: 13, name: 'Pankshin' },
		{ id: 14, name: 'Qua\'an Pan' },
		{ id: 15, name: 'Riyom' },
		{ id: 16, name: 'Shendam' },
		{ id: 17, name: 'Wase' }
	],
	Rivers: [
		{ id: 1, name: 'Abua/Odual' },
		{ id: 2, name: 'Ahoada East' },
		{ id: 3, name: 'Ahoada West' },
		{ id: 4, name: 'Akuku-Toru' },
		{ id: 5, name: 'Andoni' },
		{ id: 6, name: 'Asari-Toru' },
		{ id: 7, name: 'Bonny' },
		{ id: 8, name: 'Degema' },
		{ id: 9, name: 'Eleme' },
		{ id: 10, name: 'Emuoha' },
		{ id: 11, name: 'Etche' },
		{ id: 12, name: 'Gokana' },
		{ id: 13, name: 'Ikwerre' },
		{ id: 14, name: 'Khana' },
		{ id: 15, name: 'Obio/Akpor' },
		{ id: 16, name: 'Ogba/Egbema/Ndoni' },
		{ id: 17, name: 'Ogu/Bolo' },
		{ id: 18, name: 'Okrika' },
		{ id: 19, name: 'Omuma' },
		{ id: 20, name: 'Opobo/Nkoro' },
		{ id: 21, name: 'Oyigbo' },
		{ id: 22, name: 'Port Harcourt' },
		{ id: 23, name: 'Tai' }
	],
	Sokoto: [
		{ id: 1, name: 'Binji' },
		{ id: 2, name: 'Bodinga' },
		{ id: 3, name: 'Dange Shuni' },
		{ id: 4, name: 'Gada' },
		{ id: 5, name: 'Goronyo' },
		{ id: 6, name: 'Gudu' },
		{ id: 7, name: 'Gwadabawa' },
		{ id: 8, name: 'Illela' },
		{ id: 9, name: 'Isa' },
		{ id: 10, name: 'Kebbe' },
		{ id: 12, name: 'Kware' },
		{ id: 13, name: 'Rabah' },
		{ id: 14, name: 'Sabon Birni' },
		{ id: 15, name: 'Shagari' },
		{ id: 16, name: 'Silame' },
		{ id: 17, name: 'Sokoto North' },
		{ id: 18, name: 'Sokoto South' },
		{ id: 19, name: 'Tambuwal' },
		{ id: 20, name: 'Tangaza' },
		{ id: 21, name: 'Tureta' },
		{ id: 22, name: 'Wamako' },
		{ id: 23, name: 'Wurno' },
		{ id: 24, name: 'Yabo' }
	],
	Taraba: [
		{ id: 1, name: 'Ardo Kola' },
		{ id: 2, name: 'Bali' },
		{ id: 3, name: 'Donga' },
		{ id: 4, name: 'Gashaka' },
		{ id: 5, name: 'Gassol' },
		{ id: 6, name: 'Ibi' },
		{ id: 7, name: 'Jalingo' },
		{ id: 8, name: 'Karim Lamido' },
		{ id: 9, name: 'Kumi' },
		{ id: 10, name: 'Lau' },
		{ id: 11, name: 'Sardauna' },
		{ id: 12, name: 'Takum' },
		{ id: 13, name: 'Ussa' },
		{ id: 14, name: 'Wukari' },
		{ id: 15, name: 'Yorro' },
		{ id: 16, name: 'Zing' }
	],
	Yobe: [
		{ id: 1, name: 'Bade' },
		{ id: 2, name: 'Bursari' },
		{ id: 3, name: 'Damaturu' },
		{ id: 4, name: 'Fika' },
		{ id: 5, name: 'Fune' },
		{ id: 6, name: 'Geidam' },
		{ id: 7, name: 'Gujba' },
		{ id: 8, name: 'Gulani' },
		{ id: 9, name: 'Jakusko' },
		{ id: 10, name: 'Karasuwa' },
		{ id: 11, name: 'Machina' },
		{ id: 12, name: 'Nangere' },
		{ id: 13, name: 'Nguru' },
		{ id: 14, name: 'Potiskum' },
		{ id: 15, name: 'Tarmuwa' },
		{ id: 16, name: 'Yunusari' },
		{ id: 17, name: 'Yusufari' }
	],
	Zamfara: [
		{ id: 1, name: 'Anka' },
		{ id: 2, name: 'Bakura' },
		{ id: 3, name: 'Birnin Magaji/Kiyaw' },
		{ id: 4, name: 'Bukkuyum' },
		{ id: 5, name: 'Bungudu' },
		{ id: 6, name: 'Chafe' },
		{ id: 7, name: 'Gummi' },
		{ id: 8, name: 'Gusau' },
		{ id: 9, name: 'Kaura Namoda' },
		{ id: 10, name: 'Maradun' },
		{ id: 11, name: 'Maru' },
		{ id: 12, name: 'Shinkafi' },
		{ id: 13, name: 'Talata Mafara' },
		{ id: 14, name: 'Zurmi' }
	],
	FCT: [
		{ id: 1, name: 'Abaji' },
		{ id: 2, name: 'Abuja Municipal Area Council' },
		{ id: 3, name: 'Bwari' },
		{ id: 4, name: 'Gwagwalada' },
		{ id: 5, name: 'Kuje' },
		{ id: 6, name: 'Kwali' }
	]



























};
























